import React, { useEffect, useState } from "react";
import { utilService } from "../../../services/utilService";
import Call from "../../../components/Shared/Call/call";
import { IonContent, IonIcon, IonModal } from "@ionic/react";
import { callOutline, closeCircleOutline, eyeOutline } from "ionicons/icons";

export const MembersCard = ({
  member,
  isCallEnabled,
  selectedUsers,
  handleGrpUserSelect,
  isSelectionEnabled,
  setMbrSpecialityValues,
  toggleSpecilityModal,
  handleClose,
  initiateApiCall
}: any) => {

  const handleSelect = () => {
    if (isSelectionEnabled) {
      handleGrpUserSelect(member);
    }
  };

  const maxSubtitleLength = 10;
  const specialityNames = member?.specialty_names
    ? member?.specialty_names?.map((speciality: any) => speciality)?.join(",")
    : member?.speciality?.map(([speciality]: any) => speciality)?.join(",");

  const shouldShowEyeIcon = specialityNames?.length > maxSubtitleLength;
  const displayedSubtitle = shouldShowEyeIcon
    ? `${specialityNames?.substring(0, maxSubtitleLength)}...`
    : specialityNames;

  const subtitleArray = Array.isArray(specialityNames)
    ? specialityNames
    : specialityNames?.split(",")?.map((item: any) => item?.trim());

  return (
    <>
      <div
        className="member-card"
        onClick={handleSelect}
        style={{
          backgroundColor:
            selectedUsers?.find(
              (selectedUser: any) => selectedUser?.guid === member?.guid
            ) && isSelectionEnabled
              ? "var(--card-activated--primary)!important"
              : "var(--input-bg-primary)",
        }}
      >
        <div className="profile-picture-container" style={{width:"3rem",height:"3rem"}}>
          <img
            className="profile-picture"
            // A null picture used to build ".../null" and fetch a 404 for
            // every member without one.
            src={
              member?.profile_pic
                ? `${utilService.getBaseUrl()}/${member.profile_pic}`
                : "assets/images/defaultProfilePic.png"
            }
            onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
              const target = e.target as HTMLImageElement;
              target.src = "assets/images/defaultProfilePic.png";
            }}
            alt=""
          />
        </div>
        <div className="profile-details-container">
          <p className="profile-name" style={{fontSize:"1.1rem"}}>{member?.first_name}</p>
         {displayedSubtitle&& <div className="speciality-Container">
            <p className="recent-message" style={{fontSize:"1rem"}}>{displayedSubtitle}</p>
            {shouldShowEyeIcon&&<div className="specialty-eye-icon" onClick={(e) => {
              e.stopPropagation()
              toggleSpecilityModal()
              setMbrSpecialityValues(subtitleArray)
              }}>
              <IonIcon icon={eyeOutline} />
            </div>}
          </div>}
        </div>
        {isCallEnabled && (
          <div style={{ fontSize: "1.5rem",color:"var(--font-color-primary)",cursor:"pointer"}} onClick={()=>{initiateApiCall()}}>
            {/* <Call
              isHidden={true}
              selectedDoctorGuid={member?.guid}
              handleClose={handleClose}
            ></Call> */}
            <IonIcon icon={callOutline}/>
          </div>
        )}
      </div>
    </>
  );
};


